import {Controller} from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static outlets = [
        'profile--description-edit-modal'
    ];

    openEditModal(event) {
        event.preventDefault();
        showPreloader();

        const data = document.getElementById('description-textarea-readonly').textContent;
        this.profileDescriptionEditModalOutlet.openModal(data);

        hidePreloader()
    }
}
